var _a, _b;
import i18nIsoCountries, { getNames } from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import { getCountryCallingCode, isValidPhoneNumber } from 'libphonenumber-js';
import { consoleLogExceptProd, sendLog } from '../logging';
import { countryInfosExistInUsers, terms } from '../models';
import { PhoneAuthAlert } from '../models/Html';
import { moveArrayElementToTop } from './_utils';
export var validateCode = function (code) { return code.length === 4; };
export var validateEmail = function (email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
};
export var validatePassword = function (password) {
    if (password.length < 6) {
        return false;
    }
    var validCharacters = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]*$/;
    if (!validCharacters.test(password)) {
        return false;
    }
    var specialCharactersOnly = /^[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]*$/;
    if (specialCharactersOnly.test(password)) {
        return false;
    }
    var hasAlphabet = /[a-zA-Z]/;
    var hasNumber = /\d/;
    if (!hasAlphabet.test(password) || !hasNumber.test(password)) {
        return false;
    }
    return true;
};
export var validateName = function (name) {
    return /^[\p{L}\p{N}\p{Z}]+$/u.test(name);
};
var setWarning = function (content, setter) { return (setter ? setter(content) : ''); };
export var checkEmail = function (email, setEmailWarning) {
    if (email.length === 0) {
        setWarning('이메일을 입력해 주세요.', setEmailWarning);
        return false;
    }
    else if (!validateEmail(email)) {
        setWarning('올바른 이메일 주소 형식으로 다시 입력해 주세요.', setEmailWarning);
        return false;
    }
    setWarning(null, setEmailWarning);
    return true;
};
export var checkEmailDuplicatePassed = function (isPassed, setEmailWarning) {
    if (!isPassed) {
        setWarning('이메일 중복 확인은 필수입니다.', setEmailWarning);
        return false;
    }
    return true;
};
export var checkPassword = function (password, setPasswordWarning) {
    if (password.length === 0) {
        setPasswordWarning('비밀번호를 입력해 주세요.');
        return false;
    }
    setPasswordWarning(null);
    return true;
};
export var checkNewPassword = function (password, passwordDoubleCheck, setPasswordWarning) {
    if (password !== passwordDoubleCheck) {
        setWarning('비밀번호가 일치하지 않습니다.', setPasswordWarning);
        return false;
    }
    else if (!validatePassword(password)) {
        setWarning('영문, 숫자 조합으로 6자 이상 입력해 주세요.', setPasswordWarning);
        return false;
    }
    setWarning(null, setPasswordWarning);
    return true;
};
export var checkName = function (name, setNameWarning) {
    if (name.length === 0) {
        setWarning('이름을 입력해 주세요.', setNameWarning);
        return false;
    }
    else if (name.length < 2) {
        setWarning('이름을 다시 확인해 주세요.', setNameWarning);
        return false;
    }
    else if (!validateName(name)) {
        setWarning('이름에 특수문자를 사용할 수 없습니다.', setNameWarning);
        return false;
    }
    setWarning(null, setNameWarning);
    return true;
};
export var checkPhoneAuth = function (isAuthentic, setPhoneAuthWarning) {
    if (!isAuthentic) {
        setWarning(PhoneAuthAlert, setPhoneAuthWarning);
        return false;
    }
    setWarning(null, setPhoneAuthWarning);
    return true;
};
export var validateBirth = function (birth) {
    var birthYear = parseInt(birth.slice(0, 4), 10);
    var birthMonth = parseInt(birth.slice(4, 6), 10);
    var birthDay = parseInt(birth.slice(6, 8), 10);
    var validateDate = function () {
        return (birthYear > 1900 &&
            birthYear <= new Date().getFullYear() &&
            birthMonth > 0 &&
            birthMonth < 13 &&
            birthDay > 0 &&
            birthDay < 32);
    };
    var isAgeUnder = function (threshold) {
        var birthDate = new Date(birthYear, birthMonth - 1, birthDay);
        var today = new Date();
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        var d = today.getDate() - birthDate.getDate();
        return age < threshold || (age === threshold && m < 0) || (age === threshold && m === 0 && d < 0);
    };
    if (birth.length === 0) {
        return { ok: false, msg: '생년월일을 입력해 주세요.' };
    }
    else if (birth.length !== 8 || isNaN(birth) || !validateDate()) {
        return { ok: false, msg: '생년월일을 다시 확인해 주세요.' };
    }
    else if (isAgeUnder(14)) {
        return { ok: false, msg: '14세 미만은 가입할 수 없어요.' };
    }
    return { ok: true };
};
export var checkBirthDate = function (birthday, setBirthDateWarning) {
    var validateRes = validateBirth(birthday);
    if (validateRes.ok) {
        setWarning(null, setBirthDateWarning);
        return true;
    }
    else {
        setWarning(validateRes.msg, setBirthDateWarning);
        return false;
    }
};
export var checkGender = function (gender) {
    return !!gender;
};
export var checkTermsAgreement = function (agreements) {
    return terms.filter(function (term) { return term.isRequired; }).every(function (term) { return agreements[term.key]; });
};
export var getCountriesInfo = function () {
    i18nIsoCountries.registerLocale(en);
    var countriesInfo = [];
    Object.entries(getNames('en')).forEach(function (_a) {
        var alpha2Code = _a[0], name = _a[1];
        try {
            var callingCode = getCountryCallingCode(alpha2Code);
            countriesInfo.push({
                alpha2Code: alpha2Code,
                name: name,
                callingCode: callingCode,
            });
        }
        catch (e) {
            if (e.message !== "Unknown country: ".concat(alpha2Code)) {
                console.log("".concat(alpha2Code, " calling code error: ").concat(e));
            }
        }
    });
    countriesInfo = countriesInfo.length > 0 ? countriesInfo : countryInfosExistInUsers;
    return moveArrayElementToTop(countriesInfo, countriesInfo.find(function (countryInfo) { return (countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.callingCode) === '82'; }));
};
export var makeOptionListFromCountriesInfo = function (countriesInfo) {
    return countriesInfo.map(function (countryInfo) { return ({
        key: countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.callingCode,
        label: "".concat((countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.callingCode) === '82' ? '대한민국' : countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.name, " +").concat(countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.callingCode),
    }); });
};
export var validatePhoneNumberWithCountryCode = function (countryCode, phoneNumber) {
    try {
        return isValidPhoneNumber("+".concat(countryCode).concat(phoneNumber));
    }
    catch (e) {
        console.log('validatePhoneNumberWithCountryCode error: ', e);
        return phoneNumber.length > 8;
    }
};
var getNextPageWithOrigin = function (nextPage, isSignup) {
    if (nextPage === void 0) { nextPage = '/'; }
    if (isSignup === void 0) { isSignup = false; }
    var isRelativePath = !/^https?:\/\//i.test(nextPage) && !/^https?:\/\//i.test(decodeURIComponent(nextPage));
    if (isRelativePath && !nextPage.startsWith('/') && !decodeURIComponent(nextPage).startsWith('/')) {
        nextPage = '/' + nextPage;
    }
    if (isSignup) {
        if (nextPage.includes('?')) {
            nextPage += '&welcome=true';
        }
        else if (decodeURIComponent(nextPage).includes('?')) {
            nextPage += encodeURIComponent('&welcome=true');
        }
        else {
            nextPage += '?welcome=true';
        }
    }
    return "".concat(isRelativePath ? window.location.origin : '').concat(nextPage);
};
var apiUrl = (_a = process.env.REACT_APP_ONLINE_API_URL) !== null && _a !== void 0 ? _a : process.env.NEXT_PUBLIC_ONLINE_API_URL;
var sccUrl = (_b = process.env.REACT_APP_SCC_URL) !== null && _b !== void 0 ? _b : process.env.NEXT_PUBLIC_SCC_URL;
export var navigateToLoginDone = function (setIsShow, userId, nextPage, isSignup) {
    if (isSignup === void 0) { isSignup = false; }
    setIsShow(false);
    var nextPageWithOrigin = decodeURIComponent(getNextPageWithOrigin(nextPage, isSignup));
    var loginDoneUrl = "".concat(sccUrl, "/loginDone?uid=").concat(userId, "&next=").concat(encodeURIComponent(nextPageWithOrigin));
    consoleLogExceptProd(true, '🙏 navigateToLoginDone - nextPage = ', nextPage);
    consoleLogExceptProd(true, '🙏 navigateToLoginDone - nextPageWithOrigin = ', nextPageWithOrigin);
    consoleLogExceptProd(true, '🙏 navigateToLoginDone - window.location.href = ', loginDoneUrl);
    window.location.href = loginDoneUrl;
};
export var kakaoLogin = function (nextPage) {
    var nextPageWithOrigin = getNextPageWithOrigin(nextPage);
    consoleLogExceptProd(true, '🙏 kakao login state - next: ', nextPageWithOrigin);
    if (typeof window !== 'undefined') {
        window.Kakao.Auth.authorize({
            redirectUri: "".concat(apiUrl, "/v1/oauth/kakao/login"),
            state: JSON.stringify({
                current: window.location.href,
                next: nextPageWithOrigin,
            }),
            prompts: 'select_account',
        });
    }
};
export var onClickKakaoLogin = function (setIsShow, CPLogger, nextPage) {
    setIsShow(false);
    sendLog("login_try_kakao", CPLogger, { brand: getBrandByLocation() });
    kakaoLogin(nextPage);
};
export var createDeviceId = function () {
    var result = [];
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < 20; i++) {
        result.push(chars.charAt(Math.floor(Math.random() * chars.length)));
    }
    return result.join('');
};
export var getBrandByLocation = function () {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return 'local';
    }
    else {
        var flag = window.location.hostname.split('spartacodingclub.kr')[0].split('.')[0].replace('test', '');
        switch (flag) {
            case '':
            case 'main':
            case 'online':
                return 'scc';
            case 'hanghae99':
                return 'hh';
            case 'swcamp':
                return 'sw';
            case 'chang':
                return 'ch';
            case 'nbcamp':
                return 'nbc';
            case 'intellipick':
                return 'ip';
            case 'ddingdong':
                return 'dd';
            case 'alumni':
                return 'alumni';
            default:
                return 'default_' + flag;
        }
    }
};
export var getPathDetail = function () {
    var brand = getBrandByLocation();
    var path = window.location.pathname;
    if (path === '/')
        return 'main';
    var pathDetail = path.split('/');
    switch (brand) {
        case 'scc':
            if (pathDetail[1] === 'catalog')
                return 'all_lecture';
            else if (pathDetail[1] === 'community')
                return 'community';
            else if (pathDetail[1] === 'blog')
                return 'blog';
            else if (pathDetail[1] === 'nb')
                return 'nb';
            else
                return 'main';
        case 'nbc':
            if (pathDetail[1] === 'ai')
                return 'ai';
            else if (pathDetail[1] === 'app')
                return 'app';
            else if (pathDetail[1] === 'web')
                return 'web';
            else if (pathDetail[1] === 'game')
                return 'game';
            else if (pathDetail[1] === 'apply-process')
                return 'apply';
            else
                return 'main';
        case 'ch':
            if (pathDetail[1] === 'network')
                return 'network';
            else if (pathDetail[1] === 'story')
                return 'blog';
            else if (pathDetail[1] === 'advisor')
                return 'advisor';
            else
                return 'main';
        case 'hh':
            if (pathDetail[2] === 'fullTime')
                return 'dev';
            else if (pathDetail[1] === 'pm')
                return 'pm';
            else if (pathDetail[2] === 'plus')
                return 'plus';
            else if (pathDetail[2] === 'webinar')
                return 'webinar';
            else if (pathDetail[2] === 'story')
                return 'blog';
            else if (pathDetail[2] === 'exhibitions')
                return 'exhibitions';
            else
                return 'main';
        case 'ip':
            if (pathDetail[1] === 'ai' && pathDetail[2] === 'compare')
                return 'ai_resume';
            else if (pathDetail[1] === 'coaching')
                return 'coaching';
            else
                return 'main';
        default:
            return 'main';
    }
};
export var getContentCategoryName = function () {
    var flag;
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        flag = window.location.port;
    }
    else {
        flag = window.location.hostname.split('spartacodingclub.kr')[0].split('.')[0].replace('test', '');
    }
    switch (flag) {
        case '':
        case 'online':
        case '3333':
        case '3000':
            return '온라인';
        case 'hanghae99':
            return '항해99';
        case 'swcamp':
            return 'SW캠프';
        case 'chang':
            return '{창}';
        case 'nbcamp':
            return '내일배움캠프';
        case 'intellipick':
            return '인텔리픽';
        case 'ddingdong':
            return '띵동코딩';
        default:
            return '로컬';
    }
};
//# sourceMappingURL=index.js.map